var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconFillEmail = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 12,
  viewBox: "0 0 15 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.6364 4.54544V10.6064C15.6364 10.9904 15.4866 11.3184 15.1865 11.5911C14.8863 11.8637 14.5264 12 14.1061 12H1.89388C1.47415 12 1.11368 11.8637 0.813555 11.5911C0.513983 11.3184 0.363647 10.9904 0.363647 10.6064V4.54544L8.01483 7.63631L15.6364 4.54544ZM15.6364 3.60621L8.01483 6.72756L0.363647 3.60621V1.39416C0.363647 1.01016 0.513983 0.681566 0.813555 0.40894C1.11368 0.136313 1.47415 0 1.89388 0H14.1061C14.5264 0 14.8863 0.136313 15.1865 0.40894C15.4866 0.681566 15.6364 1.01016 15.6364 1.39416V3.60621Z",
  fill: "white"
})));
export default SvgIconFillEmail;